<template>
    <div style="width: 100%; height: 300px;">
        <div id="taskdetailright" style="width: 100%; height: 100%;"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import Http from '../../src/apis/teach'
export default {
    name: 'taskChartRightComponent',
    props: {
        plan_id: {
            type: [Number,String],
            default: 0
        },
        task_id: {
            type: [Number,String],
            default: 0
        }
    },
    data() {
        return {
            myChart: null,
            resizeHandler: null
        }
    },
    
    mounted() {
        this.$nextTick(() => {
            this.initChart();
        });
        
        this.resizeHandler = () => {
            if (this.myChart) {
                this.myChart.resize();
            }
        };
        window.addEventListener('resize', this.resizeHandler);

        this.workDetailRightLineChart()
    },
    
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
        if (this.myChart) {
            this.myChart.dispose();
            this.myChart = null;
        }
    },
    
    methods: {
        workDetailRightLineChart() {
            Http.workDetailRightLineChart({
                plan_id: this.plan_id,
                task_id: this.task_id
            }).then(res => {
                this.initChart(res.data)
            })
        },
        initChart(data) {
            if (this.myChart) {
                this.myChart.dispose();
            }

            const chartDom = document.getElementById('taskdetailright');
            if (!chartDom) {
                console.error('未找到图表容器');
                return;
            }

            this.myChart = echarts.init(chartDom);

            var option = {
                color: ['#67C23A', '#F56C6C', '#E6A23C', '#409EFF'],
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '5%',
                    left: 'center',
                    itemGap: 15
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        center: ['50%', '65%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 18,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: data
                    }
                ]
                };

            this.myChart.setOption(option);
        }
    }
};
</script>